var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_8421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96293 5.52997C8.96332 5.02911 8.81516 4.53937 8.53718 4.12272C8.2592 3.70608 7.86389 3.38123 7.40127 3.18928C6.93864 2.99734 6.42948 2.94691 5.93818 3.04438C5.44689 3.14185 4.99555 3.38284 4.64124 3.73687C4.28693 4.0909 4.04559 4.54205 3.94773 5.03327C3.84987 5.52448 3.89989 6.03369 4.09147 6.49646C4.28305 6.95924 4.60759 7.35481 5.02401 7.63311C5.44044 7.91142 5.93006 8.05997 6.43093 8.05997C6.7633 8.0601 7.09245 7.99477 7.39957 7.86769C7.7067 7.74062 7.98579 7.5543 8.22091 7.31937C8.45602 7.08444 8.64257 6.80549 8.76988 6.49847C8.8972 6.19144 8.96279 5.86235 8.96293 5.52997",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.151 9.414C12.6406 9.40637 13.1072 9.20472 13.4482 8.85335C13.7893 8.50199 13.9769 8.02962 13.97 7.54C13.9757 7.29734 13.9328 7.05599 13.8439 6.83014C13.7549 6.60429 13.6218 6.3985 13.4521 6.22486C13.2825 6.05123 13.0799 5.91326 12.8562 5.81906C12.6325 5.72486 12.3922 5.67633 12.1495 5.67633C11.9068 5.67633 11.6665 5.72486 11.4428 5.81906C11.2191 5.91326 11.0165 6.05123 10.8469 6.22486C10.6772 6.3985 10.5441 6.60429 10.4551 6.83014C10.3662 7.05599 10.3233 7.29734 10.329 7.54C10.322 8.02928 10.5094 8.50135 10.8501 8.85266C11.1907 9.20397 11.6567 9.40584 12.146 9.414C11.7104 9.43987 11.2875 9.57023 10.9129 9.79407C10.5383 10.0179 10.2231 10.3286 9.994 10.7C9.70455 9.97203 9.21772 9.33925 8.58826 8.87286C7.95881 8.40647 7.21171 8.12496 6.431 8.06C3.984 8.06 2 10.957 2 14.53H15.312C15.317 14.421 15.333 14.317 15.333 14.206C15.333 11.561 13.909 9.416 12.151 9.414Z",
    fill: "#909090"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1612_8421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.333,
    height: 11.53,
    fill: "white",
    transform: "translate(2 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerson);
export default __webpack_public_path__ + "static/media/ic_person.913e33f2eb40fed272ef8a3b7f270d4c.svg";
export { ForwardRef as ReactComponent };